module.exports = {"411503001":"羊山街道","411503002":"前进街道","411503003":"南京路","411503004":"平桥街道","411503005":"甘岸街道","411503006":"五里店街道","411503007":"平西街道","411503008":"平东街道","411503009":"震雷山街道","411503101":"明港镇","411503102":"五里镇","411503103":"邢集镇","411503105":"平昌镇","411503106":"洋河镇","411503107":"肖王镇","411503202":"龙井乡","411503203":"胡店乡","411503205":"彭家湾乡","411503206":"长台乡","411503207":"肖店乡","411503209":"王岗乡","411503210":"高粱店乡","411503211":"查山乡","411503400":"土城街道","411503401":"明港工业管理区","411503404":"城阳城址保护区","411503405":"龙飞山","411503406":"北湖风景管理区","411503408":"农村改革发展综合试验核心区","411503410":"信阳国际家居产业小镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/411503.json
// module id = 1519
// module chunks = 0